import { apiClient } from '../api';
const BASE_URL = '/decisions';

const getAllChecklistItemsForDealList = dealId => {
  return apiClient
    .get(`${BASE_URL}/GetAllChecklistItemsForDeal?dealId=${dealId}`)
    .then(response => response.data);
};

const getChecklistItemsForQuestion = question => {
  return apiClient
    .get(`${BASE_URL}/GetChecklistItemsForQuestion?question=${question}`)
    .then(response => response.data);
};

const getChecklistForDealAndQuestion = (dealId, question) => {
  return apiClient
    .get(
      `${BASE_URL}/GetChecklistForDealAndQuestion?dealId=${dealId}&question=${question}`
    )
    .then(response => response.data);
};

const getQuestions = () => {
  return apiClient
    .get(`${BASE_URL}/GetQuestions`)
    .then(response => response.data);
};

const getChecklistForDeal = dealId => {
  return apiClient
    .get(`${BASE_URL}/GetChecklistForDeal?dealId=${dealId}`)
    .then(response => response.data);
};

const saveChecklistItems = (RequestType, ChecklistItems) => {
  apiClient
    .post(`${BASE_URL}/SaveChecklistItems`, {
      ChecklistItems
    })
    .then(response => response.data);
};

const getSections = () => {
  return apiClient
    .get(`${BASE_URL}/GetSections`)
    .then(response => response.data);
};

const getSectionChecklistItemsForDeal = (dealId, sectionId) => {
  return apiClient
    .get(
      `${BASE_URL}/GetSectionChecklistItemsForDeal?dealId=${dealId}&SectionId=${sectionId}`
    )
    .then(response => response.data);
};

const getLookupItems = inputSource => {
  return apiClient
    .get(`${BASE_URL}/GetLegalLookupItems?inputSource=${inputSource}`)
    .then(response => response.data);
};

const getLookupLists = flowId => {
  return apiClient
    .get(`${BASE_URL}/GetLookupLists?flowId=${flowId}`)
    .then(response => response.data);
};

const getDealsByGp = email => {
  return apiClient
    .get(`${BASE_URL}/GetDealsByGPEmail?email=${email}`)
    .then(response => response.data);
};

const getNegotiationHistoryForQuestion = questionId => {
  return apiClient
    .get(
      `${BASE_URL}/GetNegotiationHistoryForQuestion?questionId=${questionId}`
    )
    .then(response => response.data);
};

const createNegotiationHistory = payload => {
  apiClient
    .post(`${BASE_URL}/CreateNegotiationHistory`, payload)
    .then(response => response.data);
};

const editNegotiationHistory = negotiationRequest => {
  apiClient
    .post(`${BASE_URL}/EditNegotiationHistory`, {
      negotiationRequest
    })
    .then(response => response.data);
};

export default {
  getAllChecklistItemsForDealList,
  getChecklistItemsForQuestion,
  getChecklistForDealAndQuestion,
  getQuestions,
  getChecklistForDeal,
  saveChecklistItems,
  getSections,
  getSectionChecklistItemsForDeal,
  getLookupItems,
  getLookupLists,
  getDealsByGp,
  getNegotiationHistoryForQuestion,
  createNegotiationHistory,
  editNegotiationHistory
};
